export default "__VITE_ASSET__DAMnb7Py__"